import OrganisationListPage from './OrganisationListPage';
import _OrganisationPage from './OrganisationPage';

export const SMOrganisationPage = _OrganisationPage;
export default OrganisationListPage;
